import Material from './Material';
import { inchToString } from '../lib/unitConversions';

export const sanitize = (resin) => {
  const {
    manufacturerId,
    resinId,
    id,
    version,
    product,
    color,
    construction,
    manufacturer,
    thickness,
    resinContent,
    dk,
    df,
    warnings
  } = resin;
  return {
    manufacturerId,
    resinId,
    id,
    version,
    product,
    color,
    construction,
    manufacturer,
    thickness,
    resinContent,
    dk,
    df,
    warnings
  };
}

export class Resin extends Material{
  static restore(instance) {
    const restored = super.restore(instance);
    restored._color = instance._color;

    return restored;
  }

  get color() {
    return this._color;
  }

  get displayName() {
    return this.name || `${this} #${this.type}`;

  }

  get spaceNeeded() {
    return this.thickness_px;
  }

  get viewProps() {
    return {
      color: this.color
    }
  }

  toString(unit) {
    const { construction, thickness, product} = this;
    return `${product} ${construction}(${inchToString(thickness, unit)})`;
  }
}

export default Resin;


// WEBPACK FOOTER //
// ./src/models/Resin.js